import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import { Slide } from 'react-slideshow-image';

const properties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    arrows: true,
}

const multisigData = [
    { tag: '#role-l1', title: 'home_92', content: ['home_93', 'home_94', 'home_95', 'home_96'] },
    { tag: '#role-l2', title: 'home_97', content: ['home_98', 'home_99'] },
    { tag: '#role-l3', title: 'home_100', content: ['home_101'] },
    { tag: '#role-l4', title: 'home_102', content: ['home_103', 'home_104', 'home_105'] },
]

const sharedData = [
    { tag: '#role-m1', title: 'home_106', content: ['home_107']},
    { tag: '#role-m2', title: 'home_108', content: ['home_109', 'home_110']},
    { tag: '#role-m3', title: 'home_111', content: ['home_112', 'home_113', 'home_114', 'home_115', 'home_116', 'home_117']},
]

export default class IntroduceMultiSign extends Component {
    constructor (props) {
        super(props)
        this.state = {
            active: 'multisig',
            data: multisigData
        }
    }

    render () {
        return (
            <I18n>
                {
                    (t, { i18n }) => (
                        <div className="section" id="section8">
                            <div style={{ paddingTop: 30, paddingBottom: 100 }}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 cs8-top nav">
                                            <a className={ `btn cs8t-consnumer wow bounceInDown ${ this.state.active === 'multisig' ? 'active' : '' }` }
                                               onClick={ () => this.changeActive('multisig') }
                                               data-toggle="tab"
                                            >
                                                <span className="slant-left"/>
                                                <span className="cs8t-title">{t('home_95')}</span>
                                                <span className="slant-right"/>
                                            </a>

                                            <a className={ `btn cs8t-issuert wow bounceInDown ${ this.state.active === 'shared' ? 'active' : '' }` }
                                               data-wow-delay="1s"
                                               onClick={ () => this.changeActive('shared') }
                                               data-toggle="tab"
                                            >
                                                <span className="slant-left"/>
                                                <span className="cs8t-title">{t('home_96')}</span>
                                                <span className="slant-right"/>
                                          </a>
                                        </div>
                                    </div>
                                    <div className="row tab-content">
                                        <div>
                                            <div className="tab-pane fade in active">
                                                <div className="col-xs-12 col-sm-6 col-md-6 cs8-left wow animated slideInLeft">
                                                    <img className="img-multi-shared" src="/images/shared-wallet.png" alt=""/>
                                                </div>
                                                <div className="col-xs-12 col-sm-6 col-md-6 cs8-right">
                                                    <Slide { ...properties } id={'slide'}>
                                                        { this.renderData(t) }
                                                    </Slide>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </I18n>
        )
    }

    renderContent (t, item) {
        return (
            <React.Fragment>
                {
                    item.content.map((content, index) => {
                        return (
                            <React.Fragment key={index.toString()}>
                                <p className="multi-shared-content">{ t(content) }</p><br/>
                            </React.Fragment>
                        )
                    })
                }
            </React.Fragment>
        )
    }

    renderData (t) {
        return this.state.data.map((item, index) => {
            return (
                <div style={{ paddingLeft: 50, paddingRight: 50 }}
                     key={index.toString()}
                >
                    <h3 className="wow fadeInRightBig text-uppercase">{t(item.title)}</h3>
                    <br />
                    { this.renderContent(t, item) }
                </div>
            )
        })
    }

    changeActive (active) {
        this.setState({
            active,
            data: active === 'multisig' ? multisigData : sharedData,
        })
    }
}



// WEBPACK FOOTER //
// ./src/containers/introduce-multisign.jsx